import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { RESOURCES } from "../lib/content";

export default function Resources() {
  const { settings } = useSettings();
  const updated = settings?.resources_updated || "October 1, 2026";

  return (
    <>
      <PageHero
        eyebrow="Immediate resources"
        lines={[
          { text: "Immediate community" },
          { text: "needs come first", className: "font-serifg italic font-semibold" },
        ]}
        lead="We share verified, current resources and work with community partners to understand how Hurricane Lowell is affecting residents and businesses. In a life-threatening emergency, call 911."
      >
        <p className="font-mono text-sm text-band-muted" data-testid="resources-updated-stamp">
          Last updated: {updated}
        </p>
      </PageHero>

      <section className="wrap py-16 sm:py-20" data-testid="resources-grid">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {RESOURCES.map((group, i) => (
            <Reveal key={group.cat} delay={(i % 3) * 0.06} className="h-full">
              <div className="card-surface h-full !gap-3 !p-5">
                <h2 className="font-display text-lg font-bold leading-snug">
                  {group.cat}
                </h2>
                <ul className="flex flex-col gap-2.5">
                  {group.items.map(([name, desc, url]) => (
                    <li key={name} className="text-[0.95rem]">
                      {url && url.startsWith("http") ? (
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-bold no-underline text-primary hover:underline dark:text-accent"
                          data-testid="resource-outbound-link"
                        >
                          {name}
                        </a>
                      ) : url ? (
                        <Link
                          to={url}
                          className="font-bold no-underline text-primary hover:underline dark:text-accent"
                          data-testid="resource-internal-link"
                        >
                          {name}
                        </Link>
                      ) : (
                        <b>{name}</b>
                      )}
                      <span className="block text-sm text-muted-foreground">
                        {desc}
                      </span>
                    </li>
                  ))}
                </ul>
                <span className="mt-auto font-mono text-xs text-muted-foreground">
                  Last updated: {updated}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-border bg-muted/40">
        <div className="wrap py-16 sm:py-20">
          <Reveal className="callout max-w-2xl">
            <b className="font-display text-lg">
              Know of a resource we should list?
            </b>
            <p className="text-muted-foreground">
              Send it to us. We only publish resources we can verify are
              current.
            </p>
            <Link
              to="/contact"
              className="link-underline w-fit font-semibold text-primary dark:text-accent"
              data-testid="resources-share-link"
            >
              Share a resource
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
